import React, { useEffect } from 'react';
import {Container, Sponsor, SponsorGrid } from './styles';




const apoios = [
{ image : '/assets/evento/apoio/1.jpg', url: ''},
{ image : '/assets/evento/apoio/2.jpg', url: ''},
{ image : '/assets/evento/apoio/3.jpg', url: ''},
{ image : '/assets/evento/apoio/4.jpg', url: ''},
{ image : '/assets/evento/apoio/5.jpg', url: ''},
{ image : '/assets/evento/apoio/6.jpg', url: ''},
{ image : '/assets/evento/apoio/7.jpg', url: ''},
{ image : '/assets/evento/apoio/8.jpg', url: ''},
{ image : '/assets/evento/apoio/9.jpg', url: ''},
{ image : '/assets/evento/apoio/10.jpg', url: ''},
{ image : '/assets/evento/apoio/11.jpg', url: ''},
{ image : '/assets/evento/apoio/12.jpg', url: ''},
{ image : '/assets/evento/apoio/13.jpg', url: ''},


];

export const sponsors = [
  { image : '/assets/evento/patrocinadores/1.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/2.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/3.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/4.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/5.jpg', url: ''},
{ image : '/assets/evento/apoio/14.jpg', url: ''}
]


const FooterLayout: React.FC = ({ children }) => {

  return (

<Container>
<h2>Apoio</h2>
  <SponsorGrid>
    {apoios.map( apoio => <Sponsor background={apoio.image} key={apoio.image} />)}

  </SponsorGrid>

<h2>Patrocinadores</h2>
  <SponsorGrid>
    {sponsors.map( sponsor => <Sponsor background={sponsor.image} key={sponsor.image} />)}

  </SponsorGrid>
<br/>
          <p>
            Todos os direitos reservados - 2020
            <br />
          </p>
    
        </Container>
  );
};

export default FooterLayout;
